import React from 'react'

const NonePaymentContainer = () => (
  <p>
    Script-Runner will not process the payment, the Pharmacy will handle the payment
  </p>
)

export default NonePaymentContainer
